import { createFileRoute } from "@tanstack/react-router";
import { ResidentOverviewPage } from "@/components/app/portal/pages/resident-overview-page";

export const Route = createFileRoute("/family-portal/$residentId/")({
  head: () => ({ meta: [{ title: "Overview | People AI" }] }),
  component: FamilyOverview,
});

function FamilyOverview() {
  const { residentId } = Route.useParams();
  return <ResidentOverviewPage kind="family" residentId={residentId} />;
}
